import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MassUserValidationService {
  public self;
  public userApiUrl = environment.runtime.userManagementApiUrl;

  constructor(private httpClient: HttpClient) {
    this.self = this;
  }

  public validateEmail(control: AbstractControl): Observable<any> {
    if (!control.value || !control.parent) {
      return Observable.of(null);
    }
    return this.httpClient.get(`${this.userApiUrl}/user/mass-upload/${control.value}?batchId=${control.parent.get('batchId').value}&id=${control.parent.get('id').value}`, {}).pipe(
      map(result => {
        if (!result['isValid'] && result['errors'] && result['errors'].length) {
          return result['errors'].indexOf('EXISTING_USER') ? { duplicateEmail: true } : { existingUser: true };
        }
        return null;
      })
    );
  }

  public validateOrganizationCode(control: AbstractControl): Observable<any> {
    if (!control.value || !control.parent) {
      return Observable.of(null);
    }

    const roleCode = control.parent.get('roleCode').value;
    return this.httpClient.post(`${this.userApiUrl}/user/mass-upload/validate/organizationCode`, { organizationCode: control.value, roleCode: roleCode }).pipe(
      map(result => {
        return result['isValid'] ? null : { organizationCode: true }
      })
    );
  }
}
